<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import { RevaluationTypeEnum } from '@/saved-searches/types.ts'

import SavedSearchThumbnail from '../saved-searches/SavedSearchThumbnail.vue'

export default {
  name: 'RecentlyUsedSearchList',
  components: {
    'saved-search-thumbnail': SavedSearchThumbnail,
  },
  props: {
    searchList: { type: Array, required: true },
    selectedSearches: { type: Array, default: () => [] },
    quickFilterResults: { type: Array, default: null },
  },
  emits: ['refresh-stats', 'select-search'],
  computed: {
    ...mapGetters(['settingsUrlQuery']),
    displayedSearches() {
      return this.searchList.filter((s) => (
        _.isNull(this.quickFilterResults) || this.quickFilterResults.indexOf(s.id) !== -1
      )).map((s) => ({
        ...s,
        stayListQuery: {
          mode: s.type,
          revaluationType: RevaluationTypeEnum.UNDETERMINED,
          searchId: [s.id],
          ...this.settingsUrlQuery,
        },
      }))
    },
  },
  methods: {
    refreshStats(payload) {
      this.$emit('refresh-stats', payload)
    },
  },
}
</script>

<template>
  <div class="recently-used-search-list">
    <div class="home-list-part">
      <div class="row g-0 align-items-center">
        <h2 class="col home-list-part-title p-2">
          {{ $t('recentlyUsedSearches.title') }}
        </h2>
      </div>
      <div class="row g-0">
        <div
          v-for="search in displayedSearches"
          :key="search.id"
          class="col-3 p-2"
        >
          <saved-search-thumbnail
            :search="search"
            :selected="selectedSearches.indexOf(search.id) !== -1"
            :stay-list-query="search.stayListQuery"
            :mode="search.type"
            @select-search="$emit('select-search', search)"
            @refresh-stats="refreshStats"
          />
        </div>
      </div>
    </div>
  </div>
</template>
